// being used
import React, { useContext, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Dialog,
  IconButton,
} from "@mui/material";
import { exportPDF } from "./recordTablePDF";
import { exportCSV } from "./recordTableCSV";

import clsx from "clsx";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import DeleteIcon from "@mui/icons-material/Delete";

import styles from "../../../styles.module.css";
import { Typography } from "@material-ui/core";
import PPEForm from "./ppeForm";

import { findUserNameById } from "@thequantumhub/iam-package";
// import { findUserNameById } from "../../../utils/helperFunctions";
import { viewportContext } from "../../../context/ViewportContext";
import { updateRecordPPE } from "../../../service/endpoint-manager";

const PPERecordsComponent = ({
  ppeRecords,
  setPPERecords,
  complianceData,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  flattenQuestions,
  formatCreatedAtDate,
  strict,
  setIsDashboard,
  userNames,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { screenType } = useContext(viewportContext);

  if (!ppeRecords) return <div>Loading...</div>;

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const copyToClipboard = (record, recordIndex) => {
    if (
      complianceData &&
      complianceData.length > recordIndex &&
      typeof complianceData[recordIndex].numericValue !== "undefined"
    ) {
      let recordData = "";

      const buildRecordString = (obj, prefix = "") => {
        Object.keys(obj).forEach((key) => {
          const value = obj[key];

          if (typeof value === "object") {
            buildRecordString(value, `${prefix}${key}.`);
          } else {
            recordData += `${prefix}${key}: ${value}\n`;
          }
        });
      };

      Object.keys(record).forEach((key) => {
        if (key === "formQuestions") {
          recordData += `${key}:\n`;

          buildRecordString(record[key]);
        } else {
          recordData += `${key}: ${record[key]}\n`;
        }
      });

      recordData += `Compliance: ${complianceData[recordIndex].numericValue}%`;

      navigator.clipboard
        .writeText(recordData)
        .then(() => {})
        .catch((err) => {
          console.error("Could not copy text: ", err);
        });
    } else {
      console.error(`Invalid complianceData at index ${recordIndex}`);
    }
  };

  const handleDelete = async (recordId) => {
    try {
      const response = await updateRecordPPE(recordId, { deleted: true });
      if (response.status === 200) {
        const updatedRecords = ppeRecords.filter(
          (record) => record.id !== recordId
        );
        setPPERecords(updatedRecords);
      } else {
        console.error("Failed to delete the record", response.data);
      }
    } catch (error) {
      console.error(
        "Error deleting the record:",
        error.response ? error.response.data : error
      );
    }
  };

  return (
    <Paper className={styles.paperStyles}>
      <div>
        <div className={styles.titleButtonRow}>
          <Typography variant="h5">Observations</Typography>
          <div className={styles.exportButtonContainer}>
            <div>
              <Button
                variant="contained"
                color="primary"
                className={clsx(
                  styles.primaryButton,
                  styles.complianceTableButtons
                )}
                onClick={() => setIsDashboard(false)}
              >
                {screenType.isMobile ? "Create" : "+ New Observation"}
              </Button>
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="lg"
                fullWidth
              >
                <PPEForm />
              </Dialog>
              <Button
                variant="contained"
                color="primary"
                className={clsx(
                  styles.secondaryButton,
                  styles.complianceTableButtons
                )}
                onClick={() =>
                  exportPDF(
                    ppeRecords,
                    complianceData,
                    formatCreatedAtDate,
                    strict
                  )
                }
              >
                {screenType.isMobile ? "PDF" : "Export PDF"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={clsx(
                  styles.secondaryButton,
                  styles.complianceTableButtons
                )}
                onClick={() =>
                  exportCSV(
                    ppeRecords,
                    complianceData,
                    formatCreatedAtDate,
                    strict
                  )
                }
              >
                {screenType.isMobile ? "CSV" : "Export CSV"}
              </Button>
            </div>

            <div>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={ppeRecords.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                className={styles.tablePagination}
              />
            </div>
          </div>
        </div>
        <TableContainer className={styles.obsverationTableContainer}>
          <Table stickyHeader aria-label="ppe records">
            <TableHead>
              <TableRow>
                <TableCell>Observer</TableCell>
                <TableCell>Facility</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Collection Date</TableCell>
                <TableCell>Precautions</TableCell>
                <TableCell>HCW Type</TableCell>
                <TableCell>Compliance</TableCell>

                {ppeRecords.length > 0 &&
                  flattenQuestions(ppeRecords[0].formQuestions).map(
                    (_, index) => (
                      <TableCell key={index}>{`OP${index + 1}`}</TableCell>
                    )
                  )}
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ppeRecords
                .slice(startIndex, endIndex)
                .map((record, recordIndex) => (
                  <TableRow key={recordIndex}>
                    <TableCell>
                      {findUserNameById(
                        record.nurse,
                        userNames,
                        "user_id",
                        "userName"
                      )}
                    </TableCell>
                    <TableCell>{record.facility}</TableCell>
                    <TableCell>{record.unit}</TableCell>
                    <TableCell>
                      {formatCreatedAtDate(record.createdAt)}
                    </TableCell>
                    <TableCell>{record.precautions}</TableCell>
                    <TableCell>{record.healthCareWorker}</TableCell>
                    <TableCell>
                      {complianceData[recordIndex].numericValue}%
                    </TableCell>

                    {flattenQuestions(record.formQuestions).map(
                      (answer, index) => (
                        <TableCell key={index}>
                          {answer === "notObserved" ? "N.O" : answer}
                        </TableCell>
                      )
                    )}
                    <TableCell>
                      <div className={styles.flexContainer}>
                        <IconButton
                          onClick={() => copyToClipboard(record, recordIndex)}
                          aria-label="copy"
                        >
                          <FileCopyIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleDelete(record.id)}
                          aria-label="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Paper>
  );
};

export default PPERecordsComponent;
